import EmptyContainer from "./EmptyContainer";

import NoResultsIcon from "../icons/NoResultsIcon";

const EmptyMasksFiltered = () => {
  return (
    <EmptyContainer
      title="No s'han trobat màscares"
      description="Intenta ajustar el filtre
      per trobar el que estàs buscant."
      image={<NoResultsIcon />}
    />
  );
};
export default EmptyMasksFiltered;
